import { render, staticRenderFns } from "./BlockType19Grid.vue?vue&type=template&id=0bfb1e1d&scoped=true"
import script from "./BlockType19Grid.vue?vue&type=script&lang=ts"
export * from "./BlockType19Grid.vue?vue&type=script&lang=ts"
import style0 from "./BlockType19Grid.vue?vue&type=style&index=0&id=0bfb1e1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfb1e1d",
  null
  
)

export default component.exports